<template>
    <div class="photo_sphere">
        <div id="viewer" ref="viewer"></div>
        <VrControls :playing="playing" :zoom="zoom" @play="play" @pause="pause" @changeZoomSize="changeZoom"/>
        <template v-if="marker">
            <!-- 图片/视频列表 -->
            <div class="images_group" ref="imagesGroup" :class="{active: isShowImages}" :style="imagesGroupStyle">
                <div class="top">
                    <div>{{marker.config.name}}</div>
                    <div class="close_btn" @click="closeImagesSwiper"></div>
                </div>
                <ImagesSwiper :data="marker.config.images" @slideTap="imagesTap"/>
            </div>
            <!-- 图片/视频弹窗 -->
            <ImagesPopup :show='isShowPopup' :title="marker.config.name" :data="marker.config.images" :activeIndex="imagesActiveIndex" 
            @close='closePopup' 
            @slideTap="imagesPopupTap"
            @videoPlay="videoPlay"/>
        </template>
    </div>
</template>

<script>
import {Viewer} from '@photo-sphere-viewer/core';
import '@photo-sphere-viewer/core/index.css';
import { AutorotatePlugin } from '@photo-sphere-viewer/autorotate-plugin';
import { MarkersPlugin } from '@photo-sphere-viewer/markers-plugin';
import '@photo-sphere-viewer/markers-plugin/index.css';
import VrControls from './vrControls.vue';
import { mapState } from 'vuex';
import ImagesSwiper from './imagesSwiper.vue';
import ImagesPopup from './imagesPopup.vue';
export default {
    name: "photoSphere",
    props: ['src', 'x', 'y', 'markers', 'width', 'height'],
    data() {
        return {
            viewer: null,
            AutorotatePlugin: null,
            MarkersPlugin: null,
            playing: false, //播放状态
            loading: false, //加载
            zoom: 0,

            marker: null,
            markerHtml: '',
            isShowImages: false, //pc端图片集
            imagesGroupStyle: { top: 0, left: 0 }, //pc端图片集样式
            isShowPopup: false, //图片集详情图,移动端坐标点击以后直接会显示这个弹窗
            imagesActiveIndex: null, //图片集详情索引
        };
    },
    computed: {
        ...mapState(['isPhone']),
    },
    components: {
        VrControls,
        ImagesSwiper,
        ImagesPopup
    },
    mounted() {
        this.viewer = new Viewer({
            container: this.$refs.viewer,
            // panorama: '/1adc82f1013908c40ec168c58b33eb3b.jpg',
            defaultZoomLvl: this.zoom,
            loadingImg: require('@/assets/images/icon_panorama_loading_img.gif'),
            navbar: false,
            moveInertia: true,
            plugins: [
                [
                    AutorotatePlugin, {
                        autostartDelay: 0,
                        autorotateSpeed: '0.5rpm',
                        autostartOnIdle: false,
                    },
                ],
                MarkersPlugin,
            ],
        });
        // 加载完成
        // this.viewer.addEventListener('panorama-loaded', () => {
        //     this.loading = false;
        // })
        // 缩放
        this.viewer.addEventListener('zoom-updated', ({ zoomLevel }) => {
            this.zoom = zoomLevel;
        })
        // 拖拽导致位置更新
        this.viewer.addEventListener('position-updated', () => {
            if (this.isShowImages || this.isShowPopup) { 
                this.closeImagesSwiper();
            }
        })
        this.AutorotatePlugin = this.viewer.getPlugin(AutorotatePlugin);
        this.AutorotatePlugin.addEventListener('autorotate', ({ autorotateEnabled }) => {
            this.playing = autorotateEnabled;
        })
        this.MarkersPlugin = this.viewer.getPlugin(MarkersPlugin);
        this.MarkersPlugin.addEventListener('select-marker', ({ marker }) => {
            this.marker = marker;
            // console.log(marker);
            this.viewer.animate({
                textureX: marker.config.x,
                textureY: marker.config.y,
                speed: '5rpm'
            }).then(() => {
                // 图片集
                if (marker.config.type == 1) { 
                    // 是否是移动端
                    if(this.isPhone){
                        // mobile
                        this.isShowPopup = true;
                        this.imagesActiveIndex = 0;
                    } else {
                        // pc
                        this.isShowImages = true;
                        // 弹窗位置
                        let transform = marker.element.style.transform;
                        let offset = transform.substring(transform.indexOf('(') + 1, transform.indexOf(')')).split(',');
                        let offset2 = marker.element.getBoundingClientRect();
                        this.imagesGroupStyle = {
                            top: parseInt(offset[1]) + offset2.height + 10 + 'px',
                            left: parseInt(offset[0]) + (offset2.width / 2) + 'px'
                        }
                        // 更新图标,记录保存旧的图标html
                        this.markerHtml = marker.config.html;
                        this.MarkersPlugin.updateMarker({
                            id: marker.config.id,
                            html: `<img src="${require('../assets/images/icon_marker_10.png')}"/>`,
                        })
                    }
                }
                // 跳转，其他全景图
                if (marker.config.type == 2) { 
                    this.$emit('tapArrow', { id: marker.config.panorama_id });
                    this.marker = null;
                }
            });
        })
    },
    destroyed() {},
    watch: {
        src: {
            handler: function(val) {
                this.$nextTick(() => {
                    this.loading = true;
                    this.MarkersPlugin.clearMarkers();
                    this.isShowImages = false;
                    this.isShowPopup = false;
                    this.imagesActiveIndex = null;
                    this.viewer.setPanorama(val, {
                        textureX: this.x ? this.x : this.width / 2,
                        textureY: this.height / 2, //this.y
                    }).then(() => {
                        this.$emit('loaded');
                        this.loading = false;
                        this.play({speed: 1});
                        this.MarkersPlugin.setMarkers(this.markers);
                    });
                })
            },
            immediate: true
        }
    },
    methods: {
        play({ speed }) { 
            this.AutorotatePlugin.stop();
            if (speed == 1) { 
                this.AutorotatePlugin.setOption('autorotateSpeed', '0.5rpm');
            }
            if (speed == 2) { 
                this.AutorotatePlugin.setOption('autorotateSpeed', '1rpm');
            }
            this.AutorotatePlugin.start();
        },
        pause() { 
            this.AutorotatePlugin.stop();
        },
        changeZoom({ zoom }) { 
            if (zoom < 0) zoom = 0;
            if (zoom > 100) zoom = 100;
            this.zoom = zoom;
            this.viewer.zoom(zoom);
        },
        // 关闭pc端图片集轮播图弹窗
        closeImagesSwiper() { 
            if(this.isPhone){
                this.isShowPopup = false;
            }else{
                this.isShowImages = false;
            }
            this.resetLastMarker();
        },
        // 图片集轮播图点击
        imagesTap(index) { 
            this.isShowPopup = true;
            this.imagesActiveIndex = index;
        },
        // 重置选中的点
        resetLastMarker() { 
            this.MarkersPlugin.updateMarker({
                id: this.marker.config.id,
                html: this.markerHtml,
            })
            this.marker = null;
        },
        closePopup() { 
            this.isShowPopup = false;
            if (this.isPhone) { 
                this.marker = null;
                this.imagesActiveIndex = null;
            }
        },
        imagesPopupTap() { 

        },
        videoPlay() { 

        },
    },
};
</script>

<style scoped lang="scss">
.photo_sphere{
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
}
#viewer{
    position: absolute;
    width: 100%;
    height: 100%;
    /deep/.psv-loader{
        border: none;
        .psv-loader-canvas{
            display: none;
        }
        .psv-loader-image{
            width: .8rem;
            @media only screen and (max-width: 640px) {
                width: 1.2rem;
            }
        }
    }
    /deep/.marker1,
    /deep/.marker2{
        cursor: pointer;
        .text{
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translate(-50%, .1rem);
            font-size: .18rem;
            font-weight: bold;
            text-decoration: underline;
            color: #fff;
            white-space: nowrap;
        }
    }
    /deep/.marker1{
        width: .58rem !important;
        height: .7rem !important;
        .icon{
            animation: markerIcon 1s both infinite alternate;
            @keyframes markerIcon {
                0%{
                    transform: translate(0, 20%);
                }
                100%{
                    transform: translate(0, -20%);
                }
            }
        }
    }
    /deep/.marker2{
        width: 1rem !important;
        height: .5rem !important;
        background: rgba($color: #000000, $alpha: .5);
        border-radius: 50%;
        .icon{
            animation: bounceIn 2s both infinite;
            @keyframes bounceIn {
                0% {
                    opacity: 0;
                    -webkit-transform: scale3d(0, 0, 0);
                    transform: scale3d(0, 0, 0);
                }
                20% {
                    -webkit-transform: scale3d(1.1, 1.1, 1.1);
                    transform: scale3d(1.1, 1.1, 1.1);
                }
                30% {
                    opacity: 1;
                    -webkit-transform: scale3d(1, 1, 1);
                    transform: scale3d(1, 1, 1);
                }
                99%{
                    opacity: 1;
                }
                100%{
                    opacity: 0;
                }
            }
        }
    }
}
.images_group{
    position: absolute;
    width: 0;
    height: 0;
    border-radius: .04rem;
    overflow: hidden;
    background: rgba($color: #000000, $alpha: .6);
    top: 0;
    left: 0;
    z-index: 100;
    transform: translate(-50%, 0);
    &.active{
        width: 6.5rem;
        height: auto;
    }
    .top{
        height: .3rem;
        background: rgba($color: #000000, $alpha: .6);
        font-size: .18rem;
        padding: 0 .3rem;
        color: #fff;
        line-height: .3rem;
        position: relative;
        .close_btn{
            position: absolute;
            width: .3rem;
            height: .3rem;
            cursor: pointer;
            top: 0;
            right: 0;
            &::before,
            &::after{
                content: "";
                width: .2rem;
                height: .02rem;
                background: #fff;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::after{
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
    }
}
</style>